import { render, staticRenderFns } from "./ComboboxTerritoriosFases.vue?vue&type=template&id=5744bea0"
import script from "./ComboboxTerritoriosFases.vue?vue&type=script&lang=js"
export * from "./ComboboxTerritoriosFases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports